import { render, staticRenderFns } from "./LinklistField.vue?vue&type=template&id=2b993f80&"
import script from "./LinklistField.vue?vue&type=script&lang=js&"
export * from "./LinklistField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports